export default __webpack_public_path__ + "static/media/4697@3x.009f790f.png";